<!--
 * @Author: cyl
 * @Date: 2024-01-19 13:46:18
 * @LastEditors: cyl
 * @LastEditTime: 2025-04-10 15:45:38
 * @Description: 魔方2.0-免责声明
-->
<template>
  <div style="padding: 10px 14px">
    <h3>免责声明</h3>
    <p>
      尊敬的用户，为使用{{
        activationCompany.abbreviation
      }}教学魔方服务，请您仔细阅读本《免责协议》、充分理解各条款内容。除非您已充分阅读、完全理解并接受本协议所有条款，否则，请您不要购买本服务。
      <strong>
        <u>
          您单击“同意”、“下一步”或您的购买、使用等行为或者您以其他任何明示或者默示方式表示接受本协议的，即视为您已阅读并同意本协议的约束，成为对双方均具有约束力的法律文件。
        </u>
      </strong>
    </p>
    <p>1. 用户 同意并理解我们将会尽其商业上的合理努力保障您在 本 软件服务中的数据存储安全，但是我们并不能就此提供完全保证，包括但不限于以下情形：</p>
    <p>（1）我们不对您在 本 软件服务中相关数据的删除或储存失败负责；</p>
    <p>
      （2）我们有权根据实际情况以及法律法规的要求决定您在本软件中数据的最长储存期限，您可根据自己的需要在该存储空间范围内自行备份相关数据。但因存储空间受限或技术原因、设备及网络环境等因素影响，该存储空间的数据可能出现无法全部保存、遗失或错漏等情形，我们对此不承担责任；
    </p>
    <p>
      （3）如果您停止使用软件相关功能和服务或服务被终止、取消，我们会从服务器上删除您的数据。除非适用法律法规要求，我们在服务停止、终止或取消后，没有义务向您返还任何数据。
    </p>
    <p>鉴于网络服务的特殊性，我们根据经营策略以及用户体验做出的下列行为不承担责任：</p>
    <p>（1）您同意我们可以随时变更、中断或停止部分或全部本服务；</p>
    <p>（2）我们有权定期或不定期地对提供本服务的平台或相关的设备进行检修或者维护，如因此类情况而造成本服务在合理时间内的中断或暂停，我们无需为此承担任何责任；</p>
    <p>（3）因经营策略安排或调整等原因，不同地区的用户可使用的具体本软服务的内容可能会存在差异，具体以我们实际提供的为准。为此我们不予承担任何责任。</p>
    <p>
      2.基于我们无法确保数据源所载数据的准确性、数据接收通道是否持续通畅，因此无法保证相关服务提供的持续性、及时性、准确性。如果您发现经我们接收、更新的数据存在不准确或者错误、遗漏等情况，应及时联系我们或者您信息所在的数据源进行核实。
    </p>
    <p>
      3.本软件不含有任何旨在破坏您的计算机数据和获取您的隐私信息的恶意代码。本软件经过详细的测试，但不能保证与所有的软硬件系统完全兼容，不能保证本软件完全没有错误。如果出现不兼容及软件错误的情况，您可拨打技术支持电话将情况报告我们，以获得技术支持。如果无法解决兼容性问题，您可以删除本软件。
    </p>
    <p>
      4.在适用法律允许的最大范围内，对因使用或不能使用本软件所产生的损害及风险，包括但不限于直接或间接的个人损害、商业赢利的丧失、贸易中断、商业信息的丢失或任何其它经济损失，我们不承担任何责任。
    </p>
    <p>5.您违反本协议规定，对我们造成损害的。我们有权采取包括但不限于中断使用许可、停止提供服务、限制使用、法律追究等措施。</p>
    <p>6.如您被他人投诉或您投诉他人，我们有权将争议中相关方的主体信息、联系方式、投诉相关内容等必要信息提供给相关当事方或相关部门，以便及时解决投诉纠纷，保护各方合法权益。</p>
    <p>7.因下列原因导致我们无法正常提供服务的，我们不承担责任：</p>
    <p>（1）我们承载本服务系统停机维护期间；</p>
    <p>（2）您的电脑、手机软硬件和通信线路、供电线路出现故障的；</p>
    <p>（3）您操作不当或通过非我们授权或认可的方式使用本软件服务的；</p>
    <p>（4）由于网络信号不稳定等原因，所引起的本服务登录失败、资料同步不完整等风险；</p>
    <p>（5）因病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障或政府行为等原因；</p>
    <p>（6）由于黑客攻击、网络供应商技术调整或故障、网站升级、系统方面的问题等原因而造成的本软件服务中断或延迟；</p>
    <p>（7）电信部门技术调整导致本服务中断、停止等风险；</p>
    <p>（8）因政府管制而造成本服务暂时性关闭等风险；</p>
    <p>尽管有前款约定，我们将采取合理行动积极促使服务恢复正常</p>
    <p>8.下列不可抗力原因，造成软件服务系统障碍不能执行业务的，我们不承担责任：</p>
    <p>
      （1）
      您理解并同意，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务受到影响。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争、动乱、政府行为、疫情等。出现上述情况时，我们将努力在第一时间与相关单位配合，争取及时进行处理，但是由此给您造成的损失我们在法律允许的范围内免责。
    </p>
    <p>
      （2）你理解并同意，本软件作为互联网软件，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁你的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，你应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。
    </p>
    <p>
      9.您理解并同意，在使用本服务的过程中，可能会遇到网络信息或其他用户行为带来的风险，我们不对任何信息的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：
    </p>
    <p>（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；</p>
    <p>（2）遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理上的伤害以及经济上的损失；</p>
    <p>（3）其他因网络信息或用户行为引起的风险。</p>
    <p>10.在任何情况下，您不应轻信借款、索要密码或其他涉及财产的信息。涉及财产操作的，请一定先核实对方身份，并请经常留意我们有关防范诈骗犯罪的提示。</p>
    <p>公司：{{ activationCompany.company }}</p>
    <p>电话：400-632-8880</p>
    <p>联系人：客服专员</p>
    <p>地址：{{ activationCompany.address }}</p>
  </div>
</template>
<script>
import utils from '@/utils/index'
import config from '@/config/index'
export default {
  data() {
    return {
      activationCompany: {
        company: '东莞市安道光电材料制造有限公司',
        address: '广东省东莞市松山湖国际金融园C区11栋A座',
        abbreviation: '安道'
      }
    }
  },
  created() {
    this.activationCompany = config.companyList[0]
  },
  mounted() {
    const identify = utils.getParamByUrl('cType')
    if (identify) {
      this.activationCompany = config.companyList[identify]
    }
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
h3 {
  font-size: 16px;
  text-align: center;
}

p {
  font-size: 14px;
  text-indent: 2em;
}

.underline {
  text-decoration: underline;
}

.primaryColor {
  color: #1e80ff;
}
</style>
